export default __webpack_public_path__ + "static/media/Mask of the Death God.77fbba7e.jpg";